import { Modal } from "antd";
import { Upload } from "./ot";
import React, { useEffect, useState, useRef } from "react";
import { ExclamationCircleFilled, PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import PreviewImgModal from '../permissions_list/view/PreviewImgModal'
const { confirm } = Modal;

const UploadImg = ({
    api = "/media/api/file/upload",
    defaultValue = [],
    disabled = false,
    onImagesChange = () => { },
}) => {

    const [fileList, setFileList] = useState(defaultValue || []);
    const [img, setImg] = useState("");
    const [modal_img, set_modal_img] = useState(false);

    const handleUpload = (e) => {
        e = e.file;
        let form_data = new FormData();
        form_data.append("inputFile", e);
        axios
            .post(`${api}`, form_data, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
            .then((response) => {
                let file_id = parseInt(response.data.file_id);
                const dataurl = URL.createObjectURL(e);
                const file = e;
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                });
                setFileList((prev) => {
                    let temp = [
                        ...prev,
                        {
                            file_id: file_id,
                            file_url: dataurl,
                            file: file,
                        },
                    ];
                    let data = temp.map((value) => {
                        return {
                            file_id: value?.file_id,
                            file_url: value?.file_url,
                            file: file,
                        };
                    });
                    onImagesChange(data);
                    return temp;
                });
            });
    };
    const showConfirm = (e) => {
        confirm({
            title: "確認要刪除此張圖片嗎？",
            icon: <ExclamationCircleFilled />,
            okText: "確定",
            okType: "primary",
            cancelText: "取消",
            onOk() {
                remove(e);
            },
        });
    };
    const handlePreview = (file) => {
        setImg(URL.createObjectURL(file) );
        set_modal_img(true);
    };
    const remove = (e) => {
        setFileList((prev) => {
            let data = prev
                .filter((filter_item) => parseInt(filter_item.file_id) !== parseInt(e.file_id))
                .map((value) => {
                    return {
                        file_id: value?.file_id,
                        file_url: value?.file_url,
                    };
                });
            onImagesChange(data);
            return prev.filter((filter_item) => filter_item.file_id !== e.file_id);
        });
    };
    const removefile = (e) => {
        setFileList((prev) => {
            let data = prev
                .filter((filter_item) => filter_item.file !== e)
                .map((value) => {
                    return {
                        ...value,
                        file_id: value?.file_id,
                        file_url: value?.file_url,
                    };
                });
            onImagesChange(data);
            return data;
        });
    };
    const compareToChange = () => {
        if (defaultValue) {
            let compareFilelist = fileList.map((value) => {
                return value?.file_id;
            });
            let defaultValuefileList = defaultValue.map((value) => {
                return value?.file_id;
            });
            compareFilelist.sort();
            defaultValuefileList.sort();
            if (
                JSON.stringify(compareFilelist) !==
                JSON.stringify(defaultValuefileList)
            ) {
                setFileList((pre) => {
                    return defaultValue.map((value) => {
                        return {
                            file_id: value?.file_id,
                            file_url: value?.file_url,
                        };
                    });
                });
            }
        }
    };
    const get_picture = (temp) => {
        (temp ?? []).forEach((element) => {
            if (element?.file_id) {
                axios
                    .get(api, {
                        responseType: "blob",
                        params: {
                            file_id: element?.file_id,
                        },
                    })
                    .then((response) => {
                        var blob_ = new Blob([response.data], {
                            type: "image/jpg", // this is the only MIME for SVG
                        });
                        const dataurl = URL.createObjectURL(blob_);
                        const file = new File([blob_], `${element?.file_id}.png`, {
                            type: blob_.type || "image/png",
                            lastModified: new Date(),
                        });
                        Object.assign(file, {
                            preview: URL.createObjectURL(file),
                        });
                        setFileList((pre) => {
                            let tem = pre.map((value, index) => {
                                if (parseInt(element?.file_id) === parseInt(value?.file_id)) {
                                    return {
                                        ...value,
                                        file_id: value?.file_id,
                                        file_url: dataurl,
                                        file: file,
                                    };
                                } else {
                                    return {
                                        ...value,
                                    };
                                }
                            });

                            return tem;
                        });
                    });
            }
        });
    };

    useEffect(() => {
        if(Array.isArray(defaultValue)){
            get_picture(defaultValue);
            compareToChange();
        }
    }, [defaultValue]);


    return (
        <>
            <PreviewImgModal
                modal_img={modal_img}
                set_modal_img={set_modal_img}
                img={img}
            ></PreviewImgModal>
            <Upload
                accept="image/png,image/jpeg"
                customRequest={handleUpload}
                listType="picture-card"
                fileList={fileList
                    .filter((ele) => ele?.file)
                    .map((value) => {
                        return value?.file;
                    })}
                onPreview={handlePreview}
                onRemove={(e) => {
                    removefile(e);
                }}
                // onChange={handleUpload}
                beforeUpload={false}
                multiple={true}
                disabled={disabled}
            >
                <div>
                    <PlusOutlined />
                    <div
                        style={{
                            marginTop: 8,
                        }}
                    >
                        上傳圖片
                    </div>
                </div>
            </Upload>
        </>
    );
};
export default UploadImg;
